const purchaseCopy = {
  "es": {
    "Nuevo": "Nuevo",
    "celular": "celular",
    "Importar desde Celular": "Importar desde Celular",
    "Orden": "Orden",
    "Ordenes de Compra": "Ordenes de Compra",
    "Proveedores": "Proveedores",
    "prod.": "prod.",
    "Creada:": "Creada:",
    "Entrega:": "Entrega:",
    "Total": "Total",
    "Aprobar": "Aprobar",
    "Marcar como recibida": "Marcar como recibida",
    "Compartir orden": "Compartir orden",
    "No hay proveedores": "No hay proveedores",
    "Editar Proveedor": "Editar Proveedor",
    "Nuevo Proveedor": "Nuevo Proveedor",
    "Nueva Orden de Compra": "Nueva Orden de Compra",
    "Nombre de la Empresa *": "Nombre de la Empresa *",
    "Nombre de Contacto": "Nombre de Contacto",
    "Guardar": "Guardar",
    "Agregar": "Agregar",
    "Proveedor *": "Proveedor *",
    "Seleccionar proveedor...": "Seleccionar proveedor...",
    "Fecha de Entrega Esperada": "Fecha de Entrega Esperada",
    "Agregar Productos": "Agregar Productos",
    "Producto": "Producto",
    "Nombre del producto": "Nombre del producto",
    "Cantidad": "Cantidad",
    "Cant.": "Cant.",
    "Precio unitario": "Precio unitario",
    "Agregar a la Orden": "Agregar a la Orden",
    "Crear Orden": "Crear Orden",
    "Enviar Orden de Compra": "Enviar Orden de Compra",
    "Orden #": "Orden #",
    "Proveedor:": "Proveedor:",
    "productos": "productos",
    "Selecciona cómo enviar:": "Selecciona cómo enviar:",
    "Importar Proveedores desde Excel": "Importar Proveedores desde Excel",
    "Importar Proveedores desde Celular": "Importar Proveedores desde Celular",
    "proveedores seleccionados": "proveedores seleccionados",
    "Importando...": "Importando...",
    "Importar": "Importar",
    "✅ Orden copiada al portapapeles": "✅ Orden copiada al portapapeles",
    "✅ Orden de compra compartida exitosamente!": "✅ Orden de compra compartida exitosamente!",
    "Error al compartir la orden": "Error al compartir la orden",
    "Error al leer el archivo Excel.": "Error al leer el archivo Excel.",
    "La importación de contactos del celular no está disponible en este navegador. Use la opción de Excel o abra desde su dispositivo móvil.": "La importación de contactos del celular no está disponible en este navegador. Use la opción de Excel o abra desde su dispositivo móvil.",
    "Para importar contactos del celular, use esta aplicación desde su dispositivo móvil o utilice la opción de Excel.": "Para importar contactos del celular, use esta aplicación desde su dispositivo móvil o utilice la opción de Excel.",
    "Seleccione al menos un proveedor para importar": "Seleccione al menos un proveedor para importar",
    "Importación completada: {imported} proveedores importados, {errors} errores.": "Importación completada: {imported} proveedores importados, {errors} errores.",
    "¡{imported} proveedores importados exitosamente!": "¡{imported} proveedores importados exitosamente!",
    "Error al guardar. Por favor intenta de nuevo.": "Error al guardar. Por favor intenta de nuevo.",
    "Agrega al menos un producto a la orden": "Agrega al menos un producto a la orden",
    "Completa todos los campos del producto": "Completa todos los campos del producto",
    "¿Eliminar este proveedor?": "¿Eliminar este proveedor?",
    "¿Eliminar esta orden?": "¿Eliminar esta orden?"
  },
  "en": {
    "Nuevo": "New",
    "celular": "phone",
    "Importar desde Celular": "Import from phone",
    "Orden": "Order",
    "Ordenes de Compra": "Purchase orders",
    "Proveedores": "Suppliers",
    "prod.": "items",
    "Creada:": "Created:",
    "Entrega:": "Delivery:",
    "Total": "Total",
    "Aprobar": "Approve",
    "Marcar como recibida": "Mark as received",
    "Compartir orden": "Share order",
    "No hay proveedores": "No suppliers",
    "Editar Proveedor": "Edit supplier",
    "Nuevo Proveedor": "New supplier",
    "Nueva Orden de Compra": "New purchase order",
    "Nombre de la Empresa *": "Company name *",
    "Nombre de Contacto": "Contact name",
    "Guardar": "Save",
    "Agregar": "Add",
    "Proveedor *": "Supplier *",
    "Seleccionar proveedor...": "Select supplier...",
    "Fecha de Entrega Esperada": "Expected delivery date",
    "Agregar Productos": "Add products",
    "Producto": "Product",
    "Nombre del producto": "Product name",
    "Cantidad": "Quantity",
    "Cant.": "Qty.",
    "Precio unitario": "Unit price",
    "Agregar a la Orden": "Add to order",
    "Crear Orden": "Create order",
    "Enviar Orden de Compra": "Send purchase order",
    "Orden #": "Order #",
    "Proveedor:": "Supplier:",
    "productos": "products",
    "Selecciona cómo enviar:": "Choose how to send:",
    "Importar Proveedores desde Excel": "Import suppliers from Excel",
    "Importar Proveedores desde Celular": "Import suppliers from phone",
    "proveedores seleccionados": "suppliers selected",
    "Importando...": "Importing...",
    "Importar": "Import",
    "✅ Orden copiada al portapapeles": "✅ Order copied to clipboard",
    "✅ Orden de compra compartida exitosamente!": "✅ Purchase order shared successfully!",
    "Error al compartir la orden": "Could not share the order",
    "Error al leer el archivo Excel.": "Could not read the Excel file.",
    "La importación de contactos del celular no está disponible en este navegador. Use la opción de Excel o abra desde su dispositivo móvil.": "Phone contact import is unavailable in this browser. Use Excel or open the app on your mobile device.",
    "Para importar contactos del celular, use esta aplicación desde su dispositivo móvil o utilice la opción de Excel.": "To import phone contacts, use this app on your mobile device or use Excel.",
    "Seleccione al menos un proveedor para importar": "Select at least one supplier to import",
    "Importación completada: {imported} proveedores importados, {errors} errores.": "Import complete: {imported} suppliers imported, {errors} errors.",
    "¡{imported} proveedores importados exitosamente!": "{imported} suppliers imported successfully!",
    "Error al guardar. Por favor intenta de nuevo.": "Could not save. Please try again.",
    "Agrega al menos un producto a la orden": "Add at least one product to the order",
    "Completa todos los campos del producto": "Complete all product fields",
    "¿Eliminar este proveedor?": "Delete this supplier?",
    "¿Eliminar esta orden?": "Delete this order?"
  },
  "pt": {
    "Nuevo": "Novo",
    "celular": "celular",
    "Importar desde Celular": "Importar do celular",
    "Orden": "Pedido",
    "Ordenes de Compra": "Pedidos de compra",
    "Proveedores": "Fornecedores",
    "prod.": "prod.",
    "Creada:": "Criado em:",
    "Entrega:": "Entrega:",
    "Total": "Total",
    "Aprobar": "Aprovar",
    "Marcar como recibida": "Marcar como recebido",
    "Compartir orden": "Compartilhar pedido",
    "No hay proveedores": "Nenhum fornecedor",
    "Editar Proveedor": "Editar fornecedor",
    "Nuevo Proveedor": "Novo fornecedor",
    "Nueva Orden de Compra": "Novo pedido de compra",
    "Nombre de la Empresa *": "Nome da empresa *",
    "Nombre de Contacto": "Nome do contato",
    "Guardar": "Salvar",
    "Agregar": "Adicionar",
    "Proveedor *": "Fornecedor *",
    "Seleccionar proveedor...": "Selecionar fornecedor...",
    "Fecha de Entrega Esperada": "Data de entrega prevista",
    "Agregar Productos": "Adicionar produtos",
    "Producto": "Produto",
    "Nombre del producto": "Nome do produto",
    "Cantidad": "Quantidade",
    "Cant.": "Qtd.",
    "Precio unitario": "Preço unitário",
    "Agregar a la Orden": "Adicionar ao pedido",
    "Crear Orden": "Criar pedido",
    "Enviar Orden de Compra": "Enviar pedido de compra",
    "Orden #": "Pedido nº",
    "Proveedor:": "Fornecedor:",
    "productos": "produtos",
    "Selecciona cómo enviar:": "Escolha como enviar:",
    "Importar Proveedores desde Excel": "Importar fornecedores do Excel",
    "Importar Proveedores desde Celular": "Importar fornecedores do celular",
    "proveedores seleccionados": "fornecedores selecionados",
    "Importando...": "Importando...",
    "Importar": "Importar",
    "✅ Orden copiada al portapapeles": "✅ Pedido copiado para a área de transferência",
    "✅ Orden de compra compartida exitosamente!": "✅ Pedido de compra compartilhado com sucesso!",
    "Error al compartir la orden": "Não foi possível compartilhar o pedido",
    "Error al leer el archivo Excel.": "Não foi possível ler o arquivo Excel.",
    "La importación de contactos del celular no está disponible en este navegador. Use la opción de Excel o abra desde su dispositivo móvil.": "A importação de contatos do celular não está disponível neste navegador. Use o Excel ou abra o aplicativo no seu dispositivo móvel.",
    "Para importar contactos del celular, use esta aplicación desde su dispositivo móvil o utilice la opción de Excel.": "Para importar contatos do celular, use este aplicativo no seu dispositivo móvel ou use o Excel.",
    "Seleccione al menos un proveedor para importar": "Selecione pelo menos um fornecedor para importar",
    "Importación completada: {imported} proveedores importados, {errors} errores.": "Importação concluída: {imported} fornecedores importados, {errors} erros.",
    "¡{imported} proveedores importados exitosamente!": "{imported} fornecedores importados com sucesso!",
    "Error al guardar. Por favor intenta de nuevo.": "Não foi possível salvar. Tente novamente.",
    "Agrega al menos un producto a la orden": "Adicione pelo menos um produto ao pedido",
    "Completa todos los campos del producto": "Preencha todos os campos do produto",
    "¿Eliminar este proveedor?": "Excluir este fornecedor?",
    "¿Eliminar esta orden?": "Excluir este pedido?"
  },
  "fr": {
    "Nuevo": "Nouveau",
    "celular": "téléphone",
    "Importar desde Celular": "Importer du téléphone",
    "Orden": "Commande",
    "Ordenes de Compra": "Commandes d’achat",
    "Proveedores": "Fournisseurs",
    "prod.": "art.",
    "Creada:": "Créée le :",
    "Entrega:": "Livraison :",
    "Total": "Total",
    "Aprobar": "Approuver",
    "Marcar como recibida": "Marquer comme reçue",
    "Compartir orden": "Partager la commande",
    "No hay proveedores": "Aucun fournisseur",
    "Editar Proveedor": "Modifier le fournisseur",
    "Nuevo Proveedor": "Nouveau fournisseur",
    "Nueva Orden de Compra": "Nouvelle commande d’achat",
    "Nombre de la Empresa *": "Nom de l’entreprise *",
    "Nombre de Contacto": "Nom du contact",
    "Guardar": "Enregistrer",
    "Agregar": "Ajouter",
    "Proveedor *": "Fournisseur *",
    "Seleccionar proveedor...": "Sélectionner un fournisseur...",
    "Fecha de Entrega Esperada": "Date de livraison prévue",
    "Agregar Productos": "Ajouter des produits",
    "Producto": "Produit",
    "Nombre del producto": "Nom du produit",
    "Cantidad": "Quantité",
    "Cant.": "Qté",
    "Precio unitario": "Prix unitaire",
    "Agregar a la Orden": "Ajouter à la commande",
    "Crear Orden": "Créer la commande",
    "Enviar Orden de Compra": "Envoyer la commande d’achat",
    "Orden #": "Commande nº",
    "Proveedor:": "Fournisseur :",
    "productos": "produits",
    "Selecciona cómo enviar:": "Choisissez le mode d’envoi :",
    "Importar Proveedores desde Excel": "Importer des fournisseurs depuis Excel",
    "Importar Proveedores desde Celular": "Importer des fournisseurs du téléphone",
    "proveedores seleccionados": "fournisseurs sélectionnés",
    "Importando...": "Importation...",
    "Importar": "Importer",
    "✅ Orden copiada al portapapeles": "✅ Commande copiée dans le presse-papiers",
    "✅ Orden de compra compartida exitosamente!": "✅ Commande d’achat partagée avec succès !",
    "Error al compartir la orden": "Impossible de partager la commande",
    "Error al leer el archivo Excel.": "Impossible de lire le fichier Excel.",
    "La importación de contactos del celular no está disponible en este navegador. Use la opción de Excel o abra desde su dispositivo móvil.": "L’importation des contacts du téléphone n’est pas disponible dans ce navigateur. Utilisez Excel ou ouvrez l’application sur votre appareil mobile.",
    "Para importar contactos del celular, use esta aplicación desde su dispositivo móvil o utilice la opción de Excel.": "Pour importer les contacts du téléphone, utilisez cette application sur votre appareil mobile ou utilisez Excel.",
    "Seleccione al menos un proveedor para importar": "Sélectionnez au moins un fournisseur à importer",
    "Importación completada: {imported} proveedores importados, {errors} errores.": "Importation terminée : {imported} fournisseurs importés, {errors} erreurs.",
    "¡{imported} proveedores importados exitosamente!": "{imported} fournisseurs importés avec succès !",
    "Error al guardar. Por favor intenta de nuevo.": "Impossible d’enregistrer. Veuillez réessayer.",
    "Agrega al menos un producto a la orden": "Ajoutez au moins un produit à la commande",
    "Completa todos los campos del producto": "Remplissez tous les champs du produit",
    "¿Eliminar este proveedor?": "Supprimer ce fournisseur ?",
    "¿Eliminar esta orden?": "Supprimer cette commande ?"
  }
};
Object.assign(purchaseCopy.es,{"Pendiente": "Pendiente", "Aprobada": "Aprobada", "Recibida": "Recibida", "Cancelada": "Cancelada", "ORDEN DE COMPRA": "ORDEN DE COMPRA", "NUEVA": "NUEVA", "De:": "De:", "Para:": "Para:", "Fecha:": "Fecha:", "Entrega esperada:": "Entrega esperada:", "PRODUCTOS:": "PRODUCTOS:", "TOTAL:": "TOTAL:", "Notas:": "Notas:", "Generado por BRIEFCASE": "Generado por BRIEFCASE", "Mi Negocio": "Mi Negocio", "Proveedor": "Proveedor", "c/u": "c/u", "Orden de Compra": "Orden de Compra"});
Object.assign(purchaseCopy.en,{"Pendiente": "Pending", "Aprobada": "Approved", "Recibida": "Received", "Cancelada": "Cancelled", "ORDEN DE COMPRA": "PURCHASE ORDER", "NUEVA": "NEW", "De:": "From:", "Para:": "To:", "Fecha:": "Date:", "Entrega esperada:": "Expected delivery:", "PRODUCTOS:": "PRODUCTS:", "TOTAL:": "TOTAL:", "Notas:": "Notes:", "Generado por BRIEFCASE": "Generated by BRIEFCASE", "Mi Negocio": "My Business", "Proveedor": "Supplier", "c/u": "each", "Orden de Compra": "Purchase order"});
Object.assign(purchaseCopy.pt,{"Pendiente": "Pendente", "Aprobada": "Aprovado", "Recibida": "Recebido", "Cancelada": "Cancelado", "ORDEN DE COMPRA": "PEDIDO DE COMPRA", "NUEVA": "NOVO", "De:": "De:", "Para:": "Para:", "Fecha:": "Data:", "Entrega esperada:": "Entrega prevista:", "PRODUCTOS:": "PRODUTOS:", "TOTAL:": "TOTAL:", "Notas:": "Observações:", "Generado por BRIEFCASE": "Gerado pelo BRIEFCASE", "Mi Negocio": "Minha Empresa", "Proveedor": "Fornecedor", "c/u": "cada", "Orden de Compra": "Pedido de compra"});
Object.assign(purchaseCopy.fr,{"Pendiente": "En attente", "Aprobada": "Approuvée", "Recibida": "Reçue", "Cancelada": "Annulée", "ORDEN DE COMPRA": "COMMANDE D’ACHAT", "NUEVA": "NOUVELLE", "De:": "De :", "Para:": "Pour :", "Fecha:": "Date :", "Entrega esperada:": "Livraison prévue :", "PRODUCTOS:": "PRODUITS :", "TOTAL:": "TOTAL :", "Notas:": "Notes :", "Generado por BRIEFCASE": "Généré par BRIEFCASE", "Mi Negocio": "Mon entreprise", "Proveedor": "Fournisseur", "c/u": "l’unité", "Orden de Compra": "Commande d’achat"});
export default purchaseCopy;

Object.assign(purchaseCopy.es,{"Eliminar orden de compra":"Eliminar orden de compra","Eliminar proveedor":"Eliminar proveedor","Quitar producto de la orden":"Quitar producto de la orden","Cerrar formulario de compra":"Cerrar formulario de compra","Cerrar opciones de envío":"Cerrar opciones de envío","Proveedor sin nombre":"Proveedor sin nombre"});
Object.assign(purchaseCopy.en,{"Eliminar orden de compra":"Delete purchase order","Eliminar proveedor":"Delete supplier","Quitar producto de la orden":"Remove item from order","Cerrar formulario de compra":"Close purchase form","Cerrar opciones de envío":"Close sharing options","Proveedor sin nombre":"Unnamed supplier"});
Object.assign(purchaseCopy.pt,{"Eliminar orden de compra":"Excluir pedido de compra","Eliminar proveedor":"Excluir fornecedor","Quitar producto de la orden":"Remover produto do pedido","Cerrar formulario de compra":"Fechar formulário de compra","Cerrar opciones de envío":"Fechar opções de envio","Proveedor sin nombre":"Fornecedor sem nome"});
Object.assign(purchaseCopy.fr,{"Eliminar orden de compra":"Supprimer la commande","Eliminar proveedor":"Supprimer le fournisseur","Quitar producto de la orden":"Retirer le produit de la commande","Cerrar formulario de compra":"Fermer le formulaire d’achat","Cerrar opciones de envío":"Fermer les options d’envoi","Proveedor sin nombre":"Fournisseur sans nom"});
